const featuredVideoCarouselClass = ".featured-video-carousel";

function createFeaturedVideoCarousels() {
  function init() {
    document.addEventListener("DOMContentLoaded", () => {
      document
        .querySelectorAll(featuredVideoCarouselClass)
        .forEach((carousel) => {
          createSingleCarousel(carousel).init();
        });
    });
  }

  return { init };
}

function createSingleCarousel(carousel) {
  let items;
  let media;
  let progressButtons;
  let activeIndex = 0;

  function init() {
    items = Array.from(
      carousel.querySelectorAll(`${featuredVideoCarouselClass}__item`)
    );
    media = Array.from(
      carousel.querySelectorAll(
        `${featuredVideoCarouselClass}__item--video, ${featuredVideoCarouselClass}__item--image`
      )
    );

    progressButtons = Array.from(
      carousel.querySelectorAll(
        `${featuredVideoCarouselClass}__progress--button`
      )
    );
    carousel
      .querySelectorAll(`${featuredVideoCarouselClass}__arrow--left`)
      .forEach((arrow) => {
        arrow.addEventListener("click", () => {
          const nextSlide =
            activeIndex === 0 ? items.length - 1 : activeIndex - 1;
          setActiveSlide(nextSlide);
        });
      });

    carousel
      .querySelectorAll(`${featuredVideoCarouselClass}__arrow--right`)
      .forEach((arrow) => {
        arrow.addEventListener("click", () => {
          const nextSlide =
            activeIndex === items.length - 1 ? 0 : activeIndex + 1;
          setActiveSlide(nextSlide);
        });
      });
    progressButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setActiveSlide(parseInt(button.dataset.progressIndex));
      });
    });
  }

  function setActiveSlide(nextIndex) {
    const currentSlide = items.find(
      (item) => parseInt(item.dataset.carouselContentIndex) === activeIndex
    );
    const nextSlide = items.find(
      (item) => parseInt(item.dataset.carouselContentIndex) === nextIndex
    );
    const currentMedia = media.find(
      (item) => parseInt(item.dataset.carouselMediaIndex) === activeIndex
    );
    const nextMedia = media.find(
      (item) => parseInt(item.dataset.carouselMediaIndex) === nextIndex
    );
    const currentProgress = progressButtons.find(
      (progress) => parseInt(progress.dataset.progressIndex) === activeIndex
    );
    const nextProgress = progressButtons.find(
      (progress) => parseInt(progress.dataset.progressIndex) === nextIndex
    );

    if (!nextSlide || !currentSlide || !nextProgress || !currentProgress || !currentMedia || !nextMedia) {
      return;
    }

    [currentSlide, currentMedia, currentProgress].forEach((el) =>
      el.classList.remove("active")
    );
    [nextSlide, nextMedia, nextProgress].forEach((el) =>
      el.classList.add("active")
    );
    // currentSlide.classList.remove("active");
    // currentVideoOrImage.classList.remove("active");
    // nextSlide.classList.add("active");
    // nextVideoOrImage.classList.add("active");
    // currentProgress.classList.remove("active");
    // nextProgress.classList.add("active");

    activeIndex = nextIndex;
  }

  return { init };
}

const featuredVideoCarousels = createFeaturedVideoCarousels();
featuredVideoCarousels.init();
